import { render } from "./home.vue?vue&type=template&id=f1997f38&scoped=true"
const script = {}

import "../assets/css/xg.css?vue&type=style&index=0&id=f1997f38&scoped=true&lang=css&external"
import "./home.vue?vue&type=style&index=1&id=f1997f38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1997f38"]])

export default __exports__